import app from '../../application';
import {
  showLog,
  showError,
  showWarn
} from '../../logger';
import {
  DEFAULT_AMAZON_LOAD_TIMEOUT,
  AMAZON_URL,
  AMAZON_CONFIG
} from '../../constants';

import './amazon-script';
// NOTE: 'apstag' is the global variable that Amazon searches for
var _adserverRequestResponse = false;

const REASONS = {
  ERROR_LOAD_LIBRARY:         'ERROR_LOAD_LIBRARY',
  TIMEOUT_REACHED_GLOBAL:     'TIMEOUT_REACHED_GLOBAL',
  TIMEOUT_REACHED_FETCH_BIDS: 'TIMEOUT_REACHED_FETCH_BIDS',
  ERROR_INIT_CONFIG:          'ERROR_INIT_CONFIG'
};
const {RSVP} = window;
const NAME = 'AMAZON';

export default Object.preventExtensions({
  NAME,
  isActive({hbAmazon}) {
    if (hbAmazon) {
      showLog('Amazon:Is active');
    } else {
      showLog('Amazon:Is NOT active');
    }
    return hbAmazon;
  },
  /**
   * Launch amazon behaviour
   * @param  {object}  adUnits - adUnits config
   * @param  {object}  biddersConfig
   * @param  {integer} timeout
   * @return {Promise}
   */
  getLoadPromise({hbAmazon}) {
    return new RSVP.Promise(function(resolve, reject) {
      var timeout = hbAmazon.timeout || DEFAULT_AMAZON_LOAD_TIMEOUT;

      _adserverRequestResponse = false;
      _loadLibrary()
        .then(function() {
          showLog('Amazon:getLoadPromise:Library loaded');
          return _setConfig();
        })
        .then(function() {
          showLog('Amazon:getLoadPromise:apstag is loaded');
          return _fetchBid(hbAmazon);
        })
        .then(function() {
          showLog('Amazon:getLoadPromise:Bids fetched');
          resolve(true);
        })
        .catch(function(reason) {
          reject(reason);
        });

      setTimeout(function() {
        if (!_adserverRequestResponse) {
          showWarn('Amazon:getLoadPromise:Timeout reached', timeout);
          reject(REASONS.TIMEOUT_REACHED_GLOBAL);
        }
      }, timeout);
    }).catch(function(reason) {
      switch (reason) {
        case REASONS.TIMEOUT_REACHED_GLOBAL:
          showLog('Amazon:getLoadPromise:TIMEOUT reached global');
          break;
        case REASONS.TIMEOUT_REACHED_FETCH_BIDS:
          showLog('Amazon:getLoadPromise:TIMEOUT reached in _fetchBid');
          break;
        case REASONS.ERROR_LOAD_LIBRARY:
          showError('Amazon:getLoadPromise:Error loading library');
          break;
        case REASONS.ERROR_INIT_CONFIG:
          showError('Amazon:getLoadPromise:Error on init config');
          break;
        default:
          showError('Amazon:getLoadPromise:Error in Amazon process', reason);
      }
      return false;
    });
  },

  /**
   * Force setTargeting
   */
  setTargetings() {
    if (_adserverRequestResponse) {
      window.customcmd.push(function() {
        window.apstag.setDisplayBids();
        showLog('Amazon:setTargetings:Targetings added');
      });
    } else {
      showLog('Amazon:setTargetings:Targetings NOT added because no response from bidders');
    }
  }
});

/* Private */

/**
 * Load Amazon library
 * @return {Promise}
 */
function _loadLibrary() {
  showLog('Amazon:loadLibrary:Loading library');
  return app.load(AMAZON_URL)
    .catch(function(reason) {
      showError('Amazon:loadLibrary:Error', reason);
      return RSVP.reject(REASONS.ERROR_LOAD_LIBRARY);
    });
}

/**
 * Set apstag init config
 */
function _setConfig() {
  return new RSVP.Promise(function(resolve, reject) {
    // NOTE: set custom config object
    showLog('Amazon:setConfig:Show Amazon config', AMAZON_CONFIG);
    try {
      window.apstag.init(AMAZON_CONFIG, function() {
        resolve();
      });
    } catch (error) {
      showError('Amazon:setConfig:Error', error);
      reject(REASONS.ERROR_INIT_CONFIG);
    }
  });
}

/**
 * Add slots config and make Amazon call
 * @param {object}  config - hbAmazon config from configGDPMedio
 */
function _fetchBid(config) {
  var bidConfig;

  bidConfig = {
    slots:   config.slots,
    timeout: config.timeout || DEFAULT_AMAZON_LOAD_TIMEOUT
  };

  return new RSVP.Promise(function(resolve, reject) {
    showLog('Amazon:fetchBid:Add Slots', bidConfig.slots);
    showLog('Amazon:fetchBid:Request Amazon');
    window.apstag.fetchBids(bidConfig, function(bids) {
      showLog('Amazon:fetchBid:Response from Amazon', bids);
      // NOTE: When there are no bids returned, the bids array will be empty
      if (Object.keys(bids).length === 0) {
        reject(REASONS.TIMEOUT_REACHED_FETCH_BIDS);
        return;
      }
      showLog('Amazon:fetchBid:Targetings keys', window.apstag.targetingKeys());
      _adserverRequestResponse = true;
      resolve();
    });
  });
}



// WEBPACK FOOTER //
// ./src/header-bidding/providers/amazon.js